import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import ZxingBarcodeScanner from './ZxingBarcodeScanner';
import './AddProductCamera.css';

export default function AddProductCamera({ onConfirm, onSkip, initialPhoto = '', onDraftChange }) {
  const [photo, setPhoto] = useState(initialPhoto);
  const [retaking, setRetaking] = useState(false);
  const dialog = useRef(null);
  const skip = useRef(onSkip);
  skip.current = onSkip;
  useEffect(() => {
    const before = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current?.focus();
    return () => { document.body.style.overflow = overflow; before?.focus?.({ preventScroll: true }); };
  }, []);
  const keyDown = event => {
    if (event.key === 'Escape') { event.preventDefault(); skip.current(); }
    if (event.key !== 'Tab') return;
    const controls = [...dialog.current.querySelectorAll('button:not(:disabled)')];
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && [dialog.current, first].includes(document.activeElement)) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  };
  return createPortal(<div className="add-photo-overlay">
    <section className="add-photo-modal" role="dialog" aria-modal="true" aria-labelledby="add-photo-title" tabIndex={-1} ref={dialog} onKeyDown={keyDown}>
      <header><div><h2 id="add-photo-title">{photo && !retaking ? '確認商品照片' : '先拍一張商品照'}</h2><p>接著填寫原本的商品資料，也可以直接跳過。</p></div><button type="button" className="add-photo-close" aria-label="跳過拍照，填寫商品資料" onClick={onSkip}>×</button></header>
      <div className="add-photo-camera">
        {photo && !retaking ? <><img className="add-photo-preview" src={photo} alt="待確認的商品照片"/><p className="add-photo-hint">確認後照片會帶入表單，尚未儲存商品。</p></>
          : <ZxingBarcodeScanner scanning captureLabel="拍照" onCapture={url => { setPhoto(url); onDraftChange?.(url); setRetaking(false); }} />}
      </div>
      <footer>
        <button type="button" onClick={onSkip}>跳過，先填資料</button>
        {photo && !retaking && <><button type="button" onClick={() => setRetaking(true)}>重拍</button><button type="button" className="add-photo-confirm" onClick={() => onConfirm(photo)}>使用照片，填寫資料</button></>}
        {retaking && <button type="button" onClick={() => setRetaking(false)}>保留剛才照片</button>}
      </footer>
    </section>
  </div>, document.body);
}
